angular.module('ngApp')
.controller('emissionTypeController', ['$state', function ($state) {
  $state.go('emission')
}])
